module.exports = __webpack_public_path__ + "img/btn_recor.ced17f78.png";